module.exports = __webpack_public_path__ + "static/media/nav-email.5cdf3cbc.svg";